

import React, { useEffect, useState, useCallback } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import Apiurl from "../environment/Apiurl";

function UpdateOutBilling() {
  const navigate = useNavigate();
  const { id } = useParams();
  const [patients, setPatients] = useState([]);
  const [showPatientDropdown, setShowPatientDropdown] = useState(false);
  const [isLoadingPatients, setIsLoadingPatients] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [selectedDepartment, setSelectedDepartment] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [treatmentCharges, setTreatmentCharges] = useState([]);
  const [doctorFees, setDoctorFees] = useState([]);
  const [selectedService, setSelectedService] = useState("treatment");
  const [updateData, setUpdateData] = useState({
    bill_invoice_no: "",
    hisNo: "",
    billDate: new Date().toISOString().split("T")[0],
    patientId: "",
    patientName: "",
    patientMobile: "",
    doctorName: "",
    department: "",
    category: "out",
    paymentMode: "",
    advancePaid: "0",
    balance: "0",
  });
  const [services, setServices] = useState([]);
  const [newService, setNewService] = useState({
    id: "",
    select_service: "",
    serviceType: "",
    description: "",
    amount: "",
    additionalCharges: "0",
  });
  const [isEditing, setIsEditing] = useState(false);
  const [doctor, setDoctor] = useState([]);
  const [serviceOptions, setServiceOptions] = useState([]);
  const [paymentData, setPaymentData] = useState({
    date: new Date().toISOString().split("T")[0],
    paymentMode: "",
    advancePaid: "",
    balance: "",
  });
  const [payments, setPayments] = useState([]);
  const [editIndex, setEditIndex] = useState(null);

  useEffect(() => {
    fetchInitialData();
  }, [id]);

    useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  const fetchInitialData = async () => {
    try {
      setIsLoading(true);
      await Promise.all([
        fetchBillingDetails(),
        fetchPatientDetails(),
        fetchDoctor(),
        fetchServices(),
      ]);
    } catch (error) {
      console.error("Error fetching initial data:", error);
      setErrorMessage("Failed to load initial data. Please try again.");
      setTimeout(() => setErrorMessage(""), 3000);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchBillingDetails = async () => {
    try {
      const response = await axios.get(`${Apiurl}/billing_management/${id}`);
      const billingData = response.data;

      const loadedPayments =
        billingData.bill_payment_management?.map((payment) => ({
          date: payment.date
            ? payment.date.split("T")[0]
            : new Date().toISOString().split("T")[0],
          paymentMode: payment.payment_mode || "",
          advancePaid: payment.amount || "0",
          balance: payment.balance || "0",
        })) || [];

      setUpdateData({
        bill_invoice_no: billingData.bill_invoice_no || "",
        hisNo: billingData.patient_id || "",
        billDate: billingData.bill_date
          ? billingData.bill_date.split("T")[0]
          : new Date().toISOString().split("T")[0],
        patientId: billingData.patient_id || "",
        patientName: billingData.patients_details?.[0]
          ? `${billingData.patients_details[0].first_name} ${billingData.patients_details[0].last_name}`
          : "",
        patientMobile: billingData.patients_details?.[0]?.mobile_no || "",
        doctorName: billingData.doctor_id || "",
        department: billingData.department || "",
        category: billingData.category || "out",
        paymentMode: billingData.payment_type || "",
        advancePaid: billingData.advance_paid || "0",
        balance: billingData.balance || "0",
      });

      const loadedServices =
        billingData.bill_list?.map((service) => ({
          id: service._id || Date.now().toString(),
          select_service: doctorFees.some(
            (d) => d.type === service.service_type
          )
            ? "doctor_fees"
            : "treatment",
          serviceType: service.service_type || "",
          description: service.description || "",
          amount: service.fees || "0",
          additionalCharges: service.additional_charges || "0",
        })) || [];

      setServices(loadedServices);
      setPayments(loadedPayments);
      setSelectedDepartment(billingData.department || "");
    } catch (error) {
      console.error("Error fetching billing details:", error);
      setErrorMessage("Failed to load billing details. Please try again.");
      setTimeout(() => setErrorMessage(""), 3000);
    }
  };

  const fetchServices = async () => {
    try {
      const [treatmentResponse, doctorResponse] = await Promise.all([
        axios.get(`${Apiurl}/treatment_charge`),
        axios.get(`${Apiurl}/doctor_fee_master`),
      ]);
      setTreatmentCharges(treatmentResponse.data || []);
      setDoctorFees(doctorResponse.data || []);
      setServiceOptions(treatmentResponse.data || []);
    } catch (error) {
      console.error("Error fetching services:", error);
      setErrorMessage("Failed to load services. Please try again.");
      setTimeout(() => setErrorMessage(""), 3000);
    }
  };

  const fetchPatientDetails = async () => {
    try {
      setIsLoadingPatients(true);
      const response = await axios.get(`${Apiurl}/patient_details`);
      setPatients(response.data || []);
    } catch (error) {
      console.error("Error fetching patient details:", error);
      setErrorMessage("Failed to load patients. Please try again.");
      setTimeout(() => setErrorMessage(""), 3000);
    } finally {
      setIsLoadingPatients(false);
    }
  };

  const fetchDoctor = async () => {
    try {
      setIsLoadingPatients(true);
      const response = await axios.get(`${Apiurl}/doctor`);
      setDoctor(response.data || []);
    } catch (error) {
      console.error("Error fetching doctor details:", error);
      setErrorMessage("Failed to load doctors. Please try again.");
      setTimeout(() => setErrorMessage(""), 3000);
    } finally {
      setIsLoadingPatients(false);
    }
  };

  const handlePatientSelect = (patient) => {
    setUpdateData((prev) => ({
      ...prev,
      patientId: patient.patient_id || "",
      patientName: `${patient.first_name || ""} ${patient.last_name || ""}`,
      patientMobile: patient.mobile_no || "",
      hisNo: patient.patient_id || "",
    }));
    setShowPatientDropdown(false);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setUpdateData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleServiceChange = (e) => {
    const { name, value } = e.target;
    setNewService((prev) => {
      const updatedService = { ...prev, [name]: value };

      if (name === "select_service") {
        setSelectedService(value);
        setServiceOptions(
          value === "doctor_fees" ? doctorFees : treatmentCharges
        );
        return {
          ...updatedService,
          serviceType: "",
          amount: "",
        };
      }

      if (name === "serviceType") {
        const selectedOption = serviceOptions.find(
          (option) => option.type === value
        );
        if (selectedOption) {
          updatedService.amount = selectedOption.charge_per_treatment || "";
        } else {
          updatedService.amount = "";
        }
      }

      return updatedService;
    });
  };

  const handleCancel = () => {
    fetchBillingDetails();
    setNewService({
      id: "",
      select_service: "",
      serviceType: "",
      description: "",
      amount: "",
      additionalCharges: "0",
    });
    setIsEditing(false);
    setSelectedService("treatment");
    setServiceOptions(treatmentCharges);
    setSuccessMessage("Changes have been reverted");
    setTimeout(() => setSuccessMessage(""), 3000);
  };

  const removeService = (id) => {
    if (window.confirm("Are you sure you want to delete this service?")) {
      const updatedServices = services.filter((service) => service.id !== id);
      setServices(updatedServices);
      updateTotals(updatedServices);
      setSuccessMessage("Service removed successfully");
      setTimeout(() => setSuccessMessage(""), 3000);
    }
  };

  const editService = (id) => {
    const serviceToEdit = services.find((service) => service.id === id);
    if (serviceToEdit) {
      setSelectedService(serviceToEdit.select_service);
      setServiceOptions(
        serviceToEdit.select_service === "doctor_fees"
          ? doctorFees
          : treatmentCharges
      );
      setNewService({ ...serviceToEdit });
      setIsEditing(true);
    }
  };

  const addService = () => {
    if (
      !newService.select_service ||
      !newService.serviceType ||
      !newService.amount
    ) {
      setErrorMessage("Please fill all required service fields");
      setTimeout(() => setErrorMessage(""), 3000);
      return;
    }

    let updatedServices;
    if (isEditing) {
      updatedServices = services.map((service) =>
        service.id === newService.id ? newService : service
      );
    } else {
      const newEntry = { ...newService, id: Date.now().toString() };
      updatedServices = [...services, newEntry];
    }

    setServices(updatedServices);
    setIsEditing(false);
    updateTotals(updatedServices);

    setNewService({
      id: "",
      select_service: "",
      serviceType: "",
      description: "",
      amount: "",
      additionalCharges: "0",
    });
    setSelectedService("treatment");
    setServiceOptions(treatmentCharges);

    setSuccessMessage(
      isEditing ? "Service updated successfully" : "Service added successfully"
    );
    setTimeout(() => setSuccessMessage(""), 3000);
  };

  const updateTotals = useCallback(
    (servicesArray) => {
      const subtotal = calculateSubtotal(servicesArray);
      const total = subtotal;
      const totalPaid = payments.reduce(
        (sum, payment) => sum + (parseFloat(payment.advancePaid) || 0),
        0
      );

      setUpdateData((prev) => ({
        ...prev,
        advancePaid: totalPaid.toFixed(2),
        balance: (total - totalPaid).toFixed(2),
      }));
    },
    [payments]
  );

  const calculateSubtotal = useCallback((servicesArray) => {
    return servicesArray.reduce((acc, service) => {
      const amt = parseFloat(service.amount) || 0;
      const extra = parseFloat(service.additionalCharges) || 0;
      return acc + amt + extra;
    }, 0);
  }, []);

  const calculateTotal = useCallback(() => {
    return calculateSubtotal(services);
  }, [services]);

  const calculateBalance = useCallback(() => {
    const total = calculateTotal();
    const paid = parseFloat(updateData.advancePaid) || 0;
    return total - paid;
  }, [calculateTotal, updateData.advancePaid]);

  const handlePaymentInputChange = (e) => {
    const { name, value } = e.target;
    setPaymentData((prev) => {
      const updated = { ...prev, [name]: value };

      if (name === "advancePaid") {
        const total = calculateTotal();
        let totalPaid = payments.reduce(
          (sum, p) => sum + (parseFloat(p.advancePaid) || 0),
          0
        );
        if (editIndex !== null) {
          totalPaid -= parseFloat(payments[editIndex].advancePaid || 0);
        }
        totalPaid += parseFloat(value || 0);
        updated.balance = (total - totalPaid).toFixed(2);
      }

      return updated;
    });
  };

  const handleAddOrUpdatePayment = () => {
    if (
      !paymentData.date ||
      !paymentData.paymentMode ||
      !paymentData.advancePaid
    ) {
      setErrorMessage("Please fill all payment fields");
      setTimeout(() => setErrorMessage(""), 3000);
      return;
    }

    const paidAmount = parseFloat(paymentData.advancePaid);
    if (paidAmount <= 0) {
      setErrorMessage("Payment amount must be greater than 0");
      setTimeout(() => setErrorMessage(""), 3000);
      return;
    }

    const total = calculateTotal();
    let totalPaid = payments.reduce(
      (sum, p) => sum + (parseFloat(p.advancePaid) || 0),
      0
    );

    if (editIndex !== null) {
      totalPaid -= parseFloat(payments[editIndex].advancePaid || 0);
    }

    totalPaid += paidAmount;
    const balance = total - totalPaid;

    if (balance < 0) {
      setErrorMessage("Payment amount exceeds the total due");
      setTimeout(() => setErrorMessage(""), 3000);
      return;
    }

    const updatedPayment = {
      ...paymentData,
      balance: balance.toFixed(2),
    };

    let updatedPayments;
    if (editIndex !== null) {
      updatedPayments = [...payments];
      updatedPayments[editIndex] = updatedPayment;
    } else {
      updatedPayments = [...payments, updatedPayment];
    }

    setPayments(updatedPayments);
    setEditIndex(null);

    setUpdateData((prev) => ({
      ...prev,
      advancePaid: totalPaid.toFixed(2),
      balance: balance.toFixed(2),
      paymentMode: paymentData.paymentMode,
    }));

    setPaymentData({
      date: new Date().toISOString().split("T")[0],
      paymentMode: "",
      advancePaid: "",
      balance: "",
    });

    setSuccessMessage(
      editIndex !== null
        ? "Payment updated successfully"
        : "Payment added successfully"
    );
    setTimeout(() => setSuccessMessage(""), 3000);
  };

  const handleEditPayment = (index) => {
    setPaymentData(payments[index]);
    setEditIndex(index);
  };

  const handleDeletePayment = (index) => {
    if (window.confirm("Are you sure you want to delete this payment?")) {
      const updatedPayments = [...payments];
      updatedPayments.splice(index, 1);

      const total = calculateTotal();
      const totalPaid = updatedPayments.reduce(
        (sum, p) => sum + (parseFloat(p.advancePaid) || 0),
        0
      );
      const balance = total - totalPaid;

      setPayments(updatedPayments);
      setUpdateData((prev) => ({
        ...prev,
        advancePaid: totalPaid.toFixed(2),
        balance: balance.toFixed(2),
      }));

      if (editIndex === index) {
        setEditIndex(null);
        setPaymentData({
          date: new Date().toISOString().split("T")[0],
          paymentMode: "",
          advancePaid: "",
          balance: "",
        });
      }

      setSuccessMessage("Payment deleted successfully");
      setTimeout(() => setSuccessMessage(""), 3000);
    }
  };

  const handleUpdate = async () => {
    if (
      !updateData.bill_invoice_no ||
      !updateData.billDate ||
      !updateData.patientId ||
      !updateData.department
    ) {
      setErrorMessage(
        "Please fill all required fields (Bill No, Bill Date, Patient, Department)"
      );
      setTimeout(() => setErrorMessage(""), 3000);
      return;
    }

    if (services.length === 0) {
      setErrorMessage("Please add at least one service");
      setTimeout(() => setErrorMessage(""), 3000);
      return;
    }

    if (parseFloat(updateData.balance) < 0) {
      setErrorMessage("Balance cannot be negative. Please adjust payments.");
      setTimeout(() => setErrorMessage(""), 3000);
      return;
    }

    const payload = {
      bill_invoice_no: updateData.bill_invoice_no,
      bill_date: updateData.billDate,
      patient_id: updateData.patientId,
      doctor_id: updateData.doctorName,
      department: updateData.department,
      payment_type: updateData.paymentMode || "",
      total_amount: calculateTotal().toFixed(2),
      category: updateData.category,
      advance_paid: updateData.advancePaid || "0",
      balance: updateData.balance || "0",
      updated_by: "system",
      bill_list: services.map((service) => ({
        bill_invoice_no: updateData.bill_invoice_no,
        service_type: service.serviceType,
        description: service.description,
        fees: service.amount,
        additional_charges: service.additionalCharges,
        updated_by: "system",
      })),
      payments: payments.map((payment) => ({
        date: payment.date,
        payment_mode: payment.paymentMode,
        amount: payment.advancePaid,
        balance: payment.balance,
        updated_by: "system",
      })),
    };

    try {
      await axios.put(`${Apiurl}/billing_management/${id}`, payload);
      setSuccessMessage("Billing updated successfully!");
      setTimeout(() => {
        navigate(
          `/billing/out-billing/add-billing/op-bill/${updateData.bill_invoice_no}`
        );
      }, 1000);
    } catch (error) {
      console.error("Error updating billing:", error);
      setErrorMessage(
        `Failed to update billing: ${error.response?.data?.message || error.message
        }`
      );
      setTimeout(() => setErrorMessage(""), 3000);
    }
  };

  const filteredPatients = patients.filter(
    (patient) =>
      (patient.patient_id || "")
        .toLowerCase()
        .includes(updateData.hisNo.toLowerCase()) ||
      (patient.first_name || "")
        .toLowerCase()
        .includes(updateData.hisNo.toLowerCase()) ||
      (patient.last_name || "")
        .toLowerCase()
        .includes(updateData.hisNo.toLowerCase())
  );

  if (isLoading) {
    return <div className="p-3">Loading billing data...</div>;
  }

  return (
    <div className="p-3">
      {successMessage && (
        <div
          className="alert alert-success alert-dismissible fade show"
          role="alert"
        >
          {successMessage}
          <button
            type="button"
            className="btn-close"
            onClick={() => setSuccessMessage("")}
          ></button>
        </div>
      )}
      {errorMessage && (
        <div
          className="alert alert-danger alert-dismissible fade show"
          role="alert"
        >
          {errorMessage}
          <button
            type="button"
            className="btn-close"
            onClick={() => setErrorMessage("")}
          ></button>
        </div>
      )}

      <div
        className="card py-2 mb-2"
        style={{ backgroundColor: "#01AEBE", color: "white" }}
      >
        <div className="row">
          <div className="col-lg-12 text-white">
            <h5 className="text-center">Update Out Patient Billing</h5>
          </div>
        </div>
      </div>

      <div className="row mx-auto mb-2 gap-5">
        <div className="card col-md-7">
          <div className="row mt-2">
            <div className="col-md-6 col-lg-4">
              <label className="form-label fw-semibold mb-1">Patient ID</label>
              <div style={{ position: "relative" }}>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  name="hisNo"
                  value={updateData.hisNo}
                  onChange={handleInputChange}
                  onFocus={() => setShowPatientDropdown(true)}
                  onBlur={() =>
                    setTimeout(() => setShowPatientDropdown(false), 200)
                  }
                  placeholder="Enter Patient ID"
                />
                {showPatientDropdown && (
                  <div
                    style={{
                      position: "absolute",
                      zIndex: 1000,
                      width: "100%",
                      maxHeight: "200px",
                      overflowY: "auto",
                      backgroundColor: "white",
                      border: "1px solid #ddd",
                      boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
                      marginTop: "2px",
                    }}
                  >
                    {isLoadingPatients ? (
                      <div className="dropdown-item">Loading...</div>
                    ) : filteredPatients.length > 0 ? (
                      filteredPatients.map((patient, index) => (
                        <div
                          key={index}
                          className="dropdown-item"
                          style={{ cursor: "pointer" }}
                          onMouseDown={() => handlePatientSelect(patient)}
                        >
                          {patient.patient_id} - {patient.first_name}{" "}
                          {patient.last_name}
                        </div>
                      ))
                    ) : (
                      <div className="dropdown-item text-muted">
                        No patients found
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
            <div className="col-md-6 col-lg-4">
              <label className="form-label fw-semibold mb-1">
                Patient Name
              </label>
              <input
                type="text"
                className="form-control form-control-sm"
                name="patientName"
                value={updateData.patientName}
                onChange={handleInputChange}
                readOnly
              />
            </div>
            <div className="col-md-6 col-lg-4">
              <label className="form-label fw-semibold mb-1">
                Patient Mobile
              </label>
              <input
                type="text"
                className="form-control form-control-sm"
                name="patientMobile"
                value={updateData.patientMobile}
                onChange={handleInputChange}
                readOnly
              />
            </div>
            <div className="col-md-6 col-lg-4">
              <label className="form-label fw-semibold mb-1">Department</label>
              <select
                className="form-control form-control-sm"
                name="department"
                value={updateData.department}
                onChange={(e) => {
                  handleInputChange(e);
                  setSelectedDepartment(e.target.value);
                }}
              >
                <option value="">Select Department</option>
                {[...new Set(doctor.map((doc) => doc.department))].map(
                  (dept, index) => (
                    <option key={index} value={dept}>
                      {dept}
                    </option>
                  )
                )}
              </select>
            </div>
            <div className="col-md-6 col-lg-4">
              <label className="form-label fw-semibold mb-1">Doctor Name</label>
              <select
                className="form-control form-control-sm"
                name="doctorName"
                value={updateData.doctorName}
                onChange={handleInputChange}
                disabled={!selectedDepartment}
              >
                <option value="">Select Doctor</option>
                {doctor
                  .filter((doc) => doc.department === selectedDepartment)
                  .map((doc, index) => (
                    <option key={index} value={doc.doctor_id}>
                      {doc.doctor_id} - {doc.doctor_name}
                    </option>
                  ))}
              </select>
            </div>
          </div>
        </div>
        <div className="card col-md-4">
          <div className="row mt-2">
            <div className="col-md-6 col-lg-6">
              <label className="form-label fw-semibold mb-1">Bill Date</label>
              <input
                type="date"
                className="form-control form-control-sm"
                name="billDate"
                value={updateData.billDate}
                onChange={handleInputChange}
              />
            </div>
            <div className="col-md-6 col-lg-6">
              <label className="form-label fw-semibold mb-1">Invoice No</label>
              <input
                type="text"
                className="form-control form-control-sm"
                placeholder="Auto Fill"
                name="bill_invoice_no"
                value={updateData.bill_invoice_no}
                readOnly
              />
            </div>
          </div>
        </div>
      </div>

      <div className="card shadow-sm mb-2">
        <div className="card-body">
          <div className="row g-2 rounded">
            <div className="col-md-6 col-lg-2">
              <label className="form-label fw-semibold mb-1">
                Select Service
              </label>
              <select
                className="form-select form-select-sm"
                name="select_service"
                value={newService.select_service}
                onChange={handleServiceChange}
              >
                <option value="">Select Service</option>
                <option value="treatment">Treatment charge</option>
                <option value="doctor_fees">Doctor fee</option>
              </select>
            </div>
            <div className="col-md-6 col-lg-3">
              <label className="form-label fw-semibold mb-1">
                Service Type
              </label>
              <select
                className="form-select form-control-sm"
                name="serviceType"
                value={newService.serviceType}
                onChange={handleServiceChange}
                disabled={!newService.select_service}
              >
                <option value="">Select Service Type</option>
                {serviceOptions.map((service) => (
                  <option key={service._id} value={service.type}>
                    {service.type}
                  </option>
                ))}
              </select>
            </div>
            <div className="col-md-6 col-lg-3">
              <label className="form-label fw-semibold mb-1">Description</label>
              <input
                type="text"
                className="form-control form-control-sm"
                placeholder="Enter Description"
                name="description"
                value={newService.description}
                onChange={handleServiceChange}
              />
            </div>
            <div className="col-md-6 col-lg-2">
              <label className="form-label fw-semibold mb-1">Fee (₹)</label>
              <input
                type="number"
                className="form-control form-control-sm"
                placeholder="Amount"
                name="amount"
                value={newService.amount}
                onChange={handleServiceChange}
                min="0"
                step="0.01"
              />
            </div>
            {/* <div className="col-md-6 col-lg-2">
              <label className="form-label fw-semibold mb-1">Extra (₹)</label>
              <input
                type="number"
                className="form-control form-control-sm"
                placeholder="Extra"
                name="additionalCharges"
                value={newService.additionalCharges}
                onChange={handleServiceChange}o
                min="0"
                step="0.01"
              />
            </div> */}
            <div className="col-md-12 col-lg-2 d-flex align-items-center gap-2">
              <button
                className={`btn btn-sm ${isEditing ? "btn-warning" : "btn-primary"
                  }`}
                onClick={addService}
              >
                {isEditing ? "Update" : "Add"}
              </button>
              <button
                className="btn btn-success btn-sm"
                onClick={() => setShowModal(true)}
              >
                Payment
              </button>
            </div>
          </div>

          <div className="table-responsive mt-3">
            <table className="table table-sm table-striped">
              <thead>
                <tr>
                  <th style={{ backgroundColor: "#01AEBE", color: "white" }}>
                    S.No
                  </th>
                  <th style={{ backgroundColor: "#01AEBE", color: "white" }}>
                    Service Type
                  </th>
                  <th style={{ backgroundColor: "#01AEBE", color: "white" }}>
                    Description
                  </th>
                  <th style={{ backgroundColor: "#01AEBE", color: "white" }}>
                    Amount
                  </th>
                  {/* <th style={{ backgroundColor: "#01AEBE", color: "white" }}>
                    Extra
                  </th> */}
                  <th style={{ backgroundColor: "#01AEBE", color: "white" }}>
                    Total
                  </th>
                  <th style={{ backgroundColor: "#01AEBE", color: "white" }}>
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody>
                {services.map((service, index) => (
                  <tr key={service.id}>
                    <td>{index + 1}</td>
                    <td>{service.serviceType}</td>
                    <td>{service.description || "-"}</td>
                    <td>₹{parseFloat(service.amount || 0).toFixed(2)}</td>
                    {/* <td>
                      ₹{parseFloat(service.additionalCharges || 0).toFixed(2)}
                    </td> */}
                    <td>
                      ₹
                      {(
                        parseFloat(service.amount || 0) +
                        parseFloat(service.additionalCharges || 0)
                      ).toFixed(2)}
                    </td>
                    <td>
                      <div className="btn-group" role="group">
                        <button
                          className="btn btn-outline-primary btn-sm"
                          onClick={() => editService(service.id)}
                          title="Edit"
                        >
                          <i className="fas fa-edit"></i>
                        </button>
                        <button
                          className="btn btn-outline-danger btn-sm"
                          onClick={() => removeService(service.id)}
                          title="Delete"
                        >
                          <i className="fas fa-trash"></i>
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
                {services.length === 0 && (
                  <tr>
                    <td colSpan="7" className="text-center text-muted py-3">
                      No services added yet
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-lg-12">
          <div className="card shadow-sm">
            <div className="card-body py-3">
              <div className="row">
                <div className="col-lg-8">
                  <div className="row g-3">
                    <div className="col-md-4">
                      <div className="card card-body bg-success text-white py-2">
                        <label className="form-label fw-bold mb-1">
                          Net Total
                        </label>
                        <input
                          type="text"
                          className="form-control form-control-sm"
                          value={`₹${calculateTotal().toFixed(2)}`}
                          readOnly
                        />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="card card-body bg-primary text-white py-2">
                        <label className="form-label fw-bold mb-1">Paid</label>
                        <input
                          type="text"
                          className="form-control form-control-sm"
                          value={`₹${parseFloat(
                            updateData.advancePaid || 0
                          ).toFixed(2)}`}
                          readOnly
                        />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="card card-body bg-secondary text-white py-2">
                        <label className="form-label fw-bold mb-1">
                          Balance
                        </label>
                        <input
                          type="text"
                          className="form-control form-control-sm"
                          value={`₹${parseFloat(
                            updateData.balance || 0
                          ).toFixed(2)}`}
                          readOnly
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4 d-flex align-items-center justify-content-center">
                  <div className="d-flex gap-2 flex-wrap">
                    <button
                      className="btn btn-danger"
                      onClick={() => navigate("/billing/out-billing")}
                    >
                      Back
                    </button>
                    <button
                      className="btn btn-secondary"
                      onClick={handleCancel}
                    >
                      Reset
                    </button>
                    <button
                      className="btn btn-success"
                      style={{ backgroundColor: "#01AEBE" }}
                      onClick={handleUpdate}
                    >
                      Update
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className={`modal fade ${showModal ? "show" : ""}`}
        style={{
          display: showModal ? "block" : "none",
          backgroundColor: "rgba(0,0,0,0.5)",
        }}
        tabIndex="-1"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content p-3">
            <div className="d-flex align-items-center justify-content-between mb-3">
              <h5>Payment</h5>
              <button
                className="btn btn-close"
                onClick={() => {
                  setShowModal(false);
                  setPaymentData({
                    date: new Date().toISOString().split("T")[0],
                    paymentMode: "",
                    advancePaid: "",
                    balance: "",
                  });
                  setEditIndex(null);
                }}
              ></button>
            </div>

            <div className="row g-2">
              <div className="col-md-4 col-lg-2">
                <label className="form-label fw-bold mb-1">Net Total</label>
                <input
                  type="text"
                  className="form-control fw-bold"
                  value={`₹${calculateTotal().toFixed(2)}`}
                  readOnly
                />
              </div>
              <div className="col-md-3 col-lg-3">
                <label className="form-label fw-semibold">Date</label>
                <input
                  type="date"
                  className="form-control form-control-sm"
                  name="date"
                  value={paymentData.date}
                  onChange={handlePaymentInputChange}
                />
              </div>
              <div className="col-md-3 col-lg-2">
                <label className="form-label fw-semibold">Pay Type</label>
                <select
                  className="form-select form-select-sm"
                  name="paymentMode"
                  value={paymentData.paymentMode}
                  onChange={handlePaymentInputChange}
                >
                  <option value="">Select Pay</option>
                  <option value="Cash">Cash</option>
                  <option value="Card">Card</option>
                  <option value="UPI">UPI</option>
                  <option value="Net Banking">Net Banking</option>
                </select>
              </div>
              <div className="col-md-2 col-lg-2">
                <label className="form-label fw-semibold">Paid (₹)</label>
                <input
                  type="number"
                  className="form-control form-control-sm"
                  name="advancePaid"
                  value={paymentData.advancePaid}
                  onChange={handlePaymentInputChange}
                  min="0"
                  step="0.01"
                />
              </div>
              <div className="col-md-3 col-lg-2">
                <label className="form-label fw-semibold">Balance (₹)</label>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  value={paymentData.balance}
                  readOnly
                />
              </div>
              <div className="col-md-1">
                <label className="form-label fw-semibold mb-1 d-none d-md-block">
                  &nbsp;
                </label>
                <button
                  className="btn btn-success btn-sm"
                  onClick={handleAddOrUpdatePayment}
                >
                  {editIndex !== null ? "Update" : "Add"}
                </button>
              </div>
            </div>

            <table className="table table-bordered table-sm mt-3">
              <thead>
                <tr>
                  <th style={{ backgroundColor: "#01AEBE", color: "white" }}>
                    S.No
                  </th>
                  <th style={{ backgroundColor: "#01AEBE", color: "white" }}>
                    Date
                  </th>
                  <th style={{ backgroundColor: "#01AEBE", color: "white" }}>
                    Pay Type
                  </th>
                  <th style={{ backgroundColor: "#01AEBE", color: "white" }}>
                    Paid (₹)
                  </th>
                  <th style={{ backgroundColor: "#01AEBE", color: "white" }}>
                    Balance (₹)
                  </th>
                  <th style={{ backgroundColor: "#01AEBE", color: "white" }}>
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody>
                {payments.length === 0 ? (
                  <tr>
                    <td colSpan="6" className="text-center text-muted">
                      No records
                    </td>
                  </tr>
                ) : (
                  payments.map((pay, i) => (
                    <tr key={i}>
                      <td>{i + 1}</td>
                      <td>{pay.date}</td>
                      <td>{pay.paymentMode}</td>
                      <td>₹{parseFloat(pay.advancePaid || 0).toFixed(2)}</td>
                      <td>₹{parseFloat(pay.balance || 0).toFixed(2)}</td>
                      <td>
                        <i
                          className="fas fa-edit text-primary me-2"
                          style={{ cursor: "pointer" }}
                          onClick={() => handleEditPayment(i)}
                        ></i>
                        <i
                          className="fas fa-trash text-danger"
                          style={{ cursor: "pointer" }}
                          onClick={() => handleDeletePayment(i)}
                        ></i>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
            <div className="d-flex justify-content-end">
              <button
                className="btn btn-sm btn-success"
                onClick={() => setShowModal(false)}
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default UpdateOutBilling;
